import { HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const user = JSON.parse(localStorage.getItem('user'));

    // Only add Tenant-id header, Authorization is handled by CombinedAuthInterceptor
    if (!request.headers.has('Tenant-id') && user?.tenantID) {
      request = request.clone({
        setHeaders: {
          'Tenant-id': `${user.tenantID}`,
        },
      });
    }

    return next.handle(request);
  }

  public getHTTPHeaders(): HttpHeaders {
    return new HttpHeaders().set('Content-Type', 'application/json');
  }
}
